module.exports = __webpack_public_path__ + "img/forward.9f054f7e.svg";